module.exports = __webpack_public_path__ + "static/media/logo.717aa9c1.png";